// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-vantage -> price-brothers-vantage -> residences-at-prairiefire-apartment-homes
// Generated: 2026-11-03T22:58:02.495Z
// Counts: 1 design, 68 content, 13 slot group, 2 collection binding, 8 section, 1 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments in </h1><h1>Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Inclusive access for every visitor</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Accessibility</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartment Amenities in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply for <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apply Now</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Residences at Prairiefire</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Contact Us</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Residences at Prairiefire FAQ</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>1, 2 &amp; 3-Bedroom Apartments in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Floor Plans</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.lets_talk_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Your New <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span> Apartment is Waiting</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Residences at Prairiefire Photo Gallery</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Gallery</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/in-unit-laundry-apartments-denton-tx::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability at <span data-type=\"field-token\" data-field=\"property_name\"></span> in <span data-type=\"field-token\" data-field=\"property_address_city\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Interactive Map</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments Near Prairiefire in Overland Park, KS</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Neighborhood</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Close to Shopping, Dining, and Entertainment</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet-friendly living at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 14px;\">Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Exclusive move-in savings at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferred-employer-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Preferred Employer Program</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Program Benefits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Exclusive Perks for </h2><h2>Preferred Employers</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerbenefits.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>Price Brothers Management Co. is proud to offer a Preferred Employer Program at <span data-type=\"field-token\" data-field=\"property_name\"></span>! Team members of participating companies receive waived application and administrative fees, making it even easier to call our community home. Have questions or want to see if you qualify? Contact our team—we’re here to help!</p><p>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Ready to Redeem This Offer?</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployercta.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>Take the next step toward calling <span data-type=\"field-token\" data-field=\"property_name\"></span> home — apply today and enjoy the benefits of our exclusive discount program!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.disclaimer": {
    "overrideType": "VALUE",
    "customValue": "<p><em>Program details and eligibility are subject to change at any time. Applicants must provide valid proof of employment with an approved Preferred Employer and meet all standard application requirements.</em></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Our Preferred Employers</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>How we protect your information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Privacy Policy</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.grid_heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Featured Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pay rent and manage your account</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Resident Access</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident stories from <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Reviews</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule a Tour of Residences at Prairiefire</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Schedule A Tour</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Each Price Brothers Management Co. community has its own character, amenities, and floor plans. Explore the options above to find the one that feels like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Nearby Communities From the Price Brothers Management Co.</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sister-properties-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore More Places to Call Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Navigate every page on <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Sitemap</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "studios-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover Studio Floor Plans at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>We'll be in touch soon</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Thank You</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1>Tour Our <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom apartments at <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Virtual Tours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.eyebrow": {
    "overrideType": "VALUE",
    "customValue": "<p>Ideal Location</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "preferredemployerlist.employers": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Active Military</p></li><li><p>Black &amp; Veatch</p></li><li><p>Blue Valley School District</p></li><li><p>St. Luke's Hospital</p></li><li><p>KU Medical Center</p></li><li><p>Overland Park First Responders</p></li><li><p>Overland Park Regional Medical Center</p></li><li><p>Menorah Medical Center</p></li><li><p>T-Mobile</p></li><li><p>Price Brothers Commercial Tenants</p></li><li><p>Children's Mercy Hospital</p></li><li><p>Shamrock Trading Corporation</p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_long_description"
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "multihub-lead-form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "hero.rail_schedule": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "custom_self_guided_tour_url",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "scheduletourform.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-d257-7566-976f-9052dd985a5b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resort-style pool with lounge chairs and umbrellas, featuring a multi-tiered fountain."
      }
    }
  },
  "sisterproperties.community1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a sister apartment community to Residences at Prairiefire"
      }
    }
  },
  "sisterproperties.community2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a sister apartment community to Residences at Prairiefire"
      }
    }
  },
  "sisterproperties.community3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a sister apartment community to Residences at Prairiefire"
      }
    }
  },
  "sisterproperties.community4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a sister apartment community to Residences at Prairiefire"
      }
    }
  },
  "sisterproperties.community5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a sister apartment community to Residences at Prairiefire"
      }
    }
  },
  "sisterproperties.community6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Featured photo of a sister apartment community to Residences at Prairiefire"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.amenities": {
    "limit": 8,
    "hiddenIds": null,
    "orderedIds": [
      "ec_62bbe4b13b9dc1bc84839eae",
      "ec_83f92a64749b4455f54f132e",
      "ec_eff04f8e8ae9996b211903ae",
      "ec_5f76a277865a922751b1dd17",
      "ec_e198533027fc60023355f39a",
      "ec_159b3bebfedfe905b23da0dc",
      "ec_4d8ac35380a52207262c823e",
      "ec_74ecc869f107e3d0453100bc",
      "ec_53b7ee22096c80f1b4a02499",
      "ec_2ba726dbb570ee079ea7b431",
      "ec_a4b538fca7285b11a1fc163b",
      "ec_04f6ef702031c30e88ed064a",
      "ec_bf54889acbf8bc35d128f9b6",
      "ec_b2cb432b765587ae170bfc73",
      "ec_468a81a4533f847ba42c749d",
      "ec_7b04dcb8f90531d60df3b712",
      "ec_ed0f700089b95adb8889f8de",
      "ec_854a607b4bd1014a85f6d480",
      "ec_262c23ee79369ab13f392426",
      "ec_3efcaa8db148699d74fee1ed",
      "ec_a688583f91c035116680a4a8",
      "ec_7e010cbf3deb5a6e44a81d00",
      "ec_8fda715a5e9c3ec5833daea4",
      "ec_e76c7f8e28c0a4c707e5356f",
      "ec_0742e161a604644ba2abb3e8",
      "ec_a94c8f821a7dbfd477e294a8",
      "ec_340cba6332c5db355e280fad",
      "ec_ea0571bd28f67249b1e77fd4",
      "ec_626aaeb9fdcef8106a283e94",
      "ec_b6ac009c48aacf80ae2b1c94",
      "ec_0dc5f1c4494eb3117f0464f8",
      "ec_9b1396bb57226bb3b169d34d",
      "ec_c314410bddddee6f7bd679b3",
      "ec_59b18b1b5b704a846324c64f",
      "ec_297564a82fa1fd8bd878386c",
      "ec_2f0fbce98ab806b25f634894",
      "ec_66de9b42a65e682f90459b79",
      "ec_12f8139550e4d3113959ce0b",
      "ec_e34487b3402fe02c448c4293",
      "ec_377d980b8b65a4e81623e09c",
      "ec_7f362a538acd658ce7a60afa",
      "ec_7530d8b1ce43ec3910ec3288",
      "ec_93f255c38db2266852a1cdbb",
      "ec_f26e201e2703902f00d03660",
      "ec_d20f124634c84e7916e32993",
      "ec_7f7f28cbdea26724a2aefb6d",
      "ec_cec0e433707cf2c85c66691d",
      "ec_659dfd650934c7833dcb9503"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_d71a894f2c65d7e99ac0e53b",
      "ec_0a60850e1746abdfb5073541",
      "ec_9999a7cb41d4052929ad5c3f",
      "ec_62806ee266b7da0d6b269ce0",
      "ec_dfc0d97eb4a4f83105d4a330",
      "ec_7ad4c47869843108b9b179c3",
      "ec_504705332b70ab50a7cd648d",
      "ec_127a14b9a372deaf06a052ff",
      "ec_de1335a79db0cf5e71575b90",
      "ec_dab1de3230b1a8b80c17e8aa",
      "ec_b2ca7f3c49a892a7ba5487f6",
      "ec_9886ddb46050a446294ef590",
      "ec_ec0886cd03e5d3ed1ee30644"
    ],
    "orderedIds": [
      "ec_8112f62eb7847dbe33fa5765",
      "ec_2835a6f5e7683c15ef9fbba9",
      "ec_eaf78617a7b4625efa9c8673",
      "ec_294c5c50f3caf2a0c860dd2d",
      "ec_95d2aef4d5473593f992bf52",
      "ec_dff27cd4f65fb363170554af",
      "ec_7c288c92787110ef49d4f57c",
      "ec_3ce76b4f28417bc1c8477d6b",
      "ec_210fb495380b8df9c4dda879",
      "ec_51d01a3899410ccd7571113b",
      "ec_6da644b3079c8b258e64ea32",
      "ec_b67fc6b4105b53816529df1d",
      "ec_06612cd30808aa2130b899ab",
      "ec_657ba5db7e58056096b2d031",
      "ec_de9edbff3829b4177b69c444",
      "ec_dbfa3b1e3cfbfedabdf6c150",
      "ec_3359180c3b045b5a3cd44bea",
      "ec_5de399c58a61e517bef33cce",
      "ec_7d3a570abc81eab045952469",
      "ec_ecf5423d7062a21b36270ffa",
      "ec_1592b8acbfd94ae6f28b0244",
      "ec_47f5fca70780af2aa71b6f0a",
      "ec_a34d611579d6ef83f7fc8ec8",
      "ec_07699cbead723439c9494343",
      "ec_5677f1ded889072adc52eddc",
      "ec_ec0886cd03e5d3ed1ee30644",
      "ec_9886ddb46050a446294ef590",
      "ec_de1335a79db0cf5e71575b90",
      "ec_dab1de3230b1a8b80c17e8aa",
      "ec_b2ca7f3c49a892a7ba5487f6",
      "ec_127a14b9a372deaf06a052ff",
      "ec_7ad4c47869843108b9b179c3",
      "ec_dfc0d97eb4a4f83105d4a330",
      "ec_0a60850e1746abdfb5073541",
      "ec_62806ee266b7da0d6b269ce0",
      "ec_504705332b70ab50a7cd648d",
      "ec_9999a7cb41d4052929ad5c3f",
      "ec_d71a894f2c65d7e99ac0e53b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 8
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "_section.block:apartment-sync-map": {
    "properties": {
      "paddingTop": "15px",
      "paddingRight": "15px",
      "paddingBottom": "15px",
      "paddingLeft": "15px",
      "backgroundColor": "#ffffff"
    }
  }
};
